// extracted by mini-css-extract-plugin
export default {"orderProductTable":"OrderProductTable_orderProductTable__eS7LD","tableHeader":"OrderProductTable_tableHeader__9+yQL"};